<template>
  <div
    :style="{
      backgroundColor:
        $utils.extractValue(backgroundColor, 'transparent', $route) == ''
          ? 'transparent'
          : $utils.extractValue(backgroundColor, 'transparent', $route)
    }"
    class="w-full bg-white dark:bg-dark-box-background"
    @mouseleave="hover_active = false"
    @mouseenter="hover_active = true">
    <Logo v-if="$utils.extractUrl(url, $route) == 'N/A'" class="w-96 h-96" />
    <img v-else class="h-full inline-block rounded-md" :src="$utils.extractUrl(url, $route)" alt="">
    <div
      v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
      class="absolute bottom-1 right-2 text-xs text-common-grey cursor-pointer z-50 has-tooltip">
      <Info class="text-common-grey w-4 h-4" />
      <span
        class="tooltip -mt-10 text-xs -ml-28 whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
        {{ $t("showing on") }} {{ typeof url == "object" ? $t("this page") : $t("all pages") }}</span>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/shared/Logo.vue"
import { Info } from "lucide-vue-next"

export default {
  components: { Logo, Info },

  inject: ["canUserEditLayout"],
  props: {
    url: null,
    backgroundColor: null
  },
  emits: [],
  data() {
    return {
      hover_active: false
    }
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
